import { useEffect, useState } from "react";

import { ThemeConfig } from "../dataTypes/ThemeConfig";

const useFetchThemeConfig = (slug: string | undefined) => {
  const [themeConfig, setThemeConfig] = useState<ThemeConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;

    const fetchThemeConfig = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/${slug}/public/info/simple`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setThemeConfig({
          color: data.data.color,
          name: data.data.name,
          favicon_img: data.data.favicon_img,
          logo_img: data.data.logoUrl,
          title: data.data.name,
        });
      } catch (error) {
        setError("Error fetching theme config");
        console.error("Error fetching theme config:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchThemeConfig();
  }, [slug]);

  return { themeConfig, loading, error };
};

export default useFetchThemeConfig;
